import { FocusEvent, useMemo, FC, useCallback } from 'react';

import dateService from '@gem/services/date-service';
import { noop } from '@gem/utils';

import { TextField } from '../TextField/TextField';
import { IDateFieldProps } from './DateField.types';

export const DateField: FC<IDateFieldProps> = (props) => {
  const { input, minDate, onFocus, ...rest } = props;
  const inputValue = useMemo(() => {
    const conf: { month: string; day: string; year?: string } = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    };

    return dateService.format(input.value, conf) || '';
  }, [input.value]);

  const handleChooseDate = useCallback(
    (date: Date): void => {
      new Date().setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      input.onChange(date);
    },
    [input]
  );

  const handleFocus = useCallback(
    (e: FocusEvent<HTMLInputElement>): FocusEvent<HTMLInputElement> => {
      onFocus?.({ value: input.value, onChoose: handleChooseDate, minDate });
      return e;
    },
    [input.value, handleChooseDate, minDate]
  );

  const onChangeInput = useCallback(noop, []);

  return (
    <TextField
      {...rest}
      input={{ ...input, onChange: onChangeInput, onFocus: handleFocus, value: inputValue }}
    />
  );
};
